import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
// import UnauthRoute from '../components/unauth-route';
import Tenants from '../sub-projects/tenants/main';
import TenantRoutes from './tenant';

class TenantsRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <AuthRoute exact={true} path='/console/tenants' component={Tenants} redirectTo='/' />
          <AuthRoute path='/console/tenants/:tenantid' component={TenantRoutes} redirectTo='/' />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default connect(
  mapStateToProps
)(TenantsRoutes);




// WEBPACK FOOTER //
// ./src/routes/tenants.tsx